export function generateClassName(prefix) {
  return "lcp-".concat(prefix);
}